import { KFormUser } from "@components";
import { ECardType } from "@types";
import { AttachmentsDetail } from "./Attachments";
import { SetReminderSection } from "./SetReminderSection";

export const TestResultsDetail = () => {
    return (
        <>
            <KFormUser.DatePicker label="Test Date" name="startTime" placeholder="Date Test was Performed" />
            <KFormUser.Input
                label="Test Type"
                name="type"
                placeholder="Type of Test Performed"
            />
            <KFormUser.TextArea
                label="Test Observations"
                name="observations"
                placeholder="Enter location info"
            />
            <KFormUser.TextArea label="Test Notes" name="note" placeholder="Comments about the Diagnostic Report" />
            <KFormUser.TextArea label="Test Conclusion" name="conclusion" placeholder="Summary Conclusion of the Diagnostic Report" />
            <KFormUser.OptionsSelector
                label="Ordering Practitioner"
                cardType={ECardType.Practitioners}
                placeholder="Select doctor"
            />
            <KFormUser.Input
                label="Test Provider"
                name="provider"
                placeholder="Service responsible for issuing the Diagnostic Report"
            />
            <KFormUser.OptionsSelector
                label="Primary Related Condition"
                cardType={ECardType.Conditions}
            />
            <KFormUser.TextArea label="Additional Information" name="description" />
            <AttachmentsDetail />
            <SetReminderSection />
        </>
    );
};
